import React from 'react';
import PropTypes from 'prop-types';
import { RECORDING_STATUS } from '../../../../constants/constants';
import './timer.style.css';

/**
 * Variable representing the timer component.
 * @param {object} props - The component props.
 * @return {object} jsx - The jsx component.
 * */
const Timer = ({ status, parseTimer }) => {
  if (status === RECORDING_STATUS.RECORDED
    || status === RECORDING_STATUS.RECORDING
    || status === RECORDING_STATUS.PLAYING) {
    return <div className="timer">{parseTimer}</div>;
  }

  return null;
};

export default Timer;

Timer.propTypes = {
  parseTimer: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/messages/recorder/recorder-content/timer/timer.component.js